import { apiService } from "./api";

export interface PriceListFilters {
    /** OR-of-AND-groups, e.g. [["kitten","can-food"],["senior","can-food"]] = (kitten AND can-food) OR (senior AND can-food). Built by CategoryChainBuilder's categoryChainToGroups(). */
    category_groups?: string[][];
    brand_ids?: string[];
    min_price?: number;
    max_price?: number;
    active_only?: boolean;
    in_stock_only?: boolean;
    search_query?: string;
}

export interface PriceListProduct {
    product_id: string;
    name: string;
    sku: string;
    category_name?: string;
    brand_name?: string;
    price: number;
    stock_quantity: number;
    is_active: boolean;
}

export interface GenerateMessageRequest {
    product_ids: string[];
    format: "simple" | "categorized" | "detailed" | "promotional";
    include_emojis: boolean;
    include_stock: boolean;
    custom_header?: string;
    custom_footer?: string;
}

export interface GenerateMessageResponse {
    message: string;
    character_count: number;
    product_count: number;
    preview_url?: string;
}

export interface CategoryWithCount {
    category_id: string;
    name: string;
    parent_id?: string;
    product_count: number;
}

export interface BrandWithCount {
    brand_id: string;
    name: string;
    product_count: number;
}

class ToolsService {
    async filterProductsForPriceList(
        filters: PriceListFilters,
    ): Promise<PriceListProduct[]> {
        return await apiService.post<PriceListProduct[]>(
            "/tools/price-list/filter",
            filters,
        );
    }

    async generatePriceListMessage(
        request: GenerateMessageRequest,
    ): Promise<GenerateMessageResponse> {
        return await apiService.post<GenerateMessageResponse>(
            "/tools/price-list/generate-message",
            request,
        );
    }

    async getCategoriesForPriceList(): Promise<CategoryWithCount[]> {
        return await apiService.get<CategoryWithCount[]>(
            "/tools/price-list/categories",
        );
    }

    async getBrandsForPriceList(): Promise<BrandWithCount[]> {
        return await apiService.get<BrandWithCount[]>(
            "/tools/price-list/brands",
        );
    }
}

export const toolsService = new ToolsService();
